// extracted by mini-css-extract-plugin
export default {"promotion-highlight-text":"promotion-highlight-text--tDUTD","promotionHighlightText":"promotion-highlight-text--tDUTD"};